module.exports = __webpack_public_path__ + "static/media/rm_06-01.d796d174.png";